<div class="punch-card">
  <div class="punch-card__header" [style.background-color]="headerColor">
    <div class="punch-card__title">{{ title }}</div>
    <button mat-mini-fab color="primary" class="punch-card__open-button" aria-label="Open punch details" (click)="onOpenClick()">
      <mat-icon>open_in_new</mat-icon>
    </button>
  </div>

  <div class="punch-card__body">
    <!-- Punch identity row: always present when we have project or punch id -->
    @if (punch.projectId != null || punch.punchId != null) {
      <div class="punch-card__row">
        <span class="punch-card__label">
          <span class="punch-card__label-inline">
            @if (punch.category) {
              <app-status-circle [status]="punch.category"></app-status-circle>
            }
            <span>Punch</span>
          </span>
        </span>
        <span class="punch-card__value">
          @if (punch.projectId != null && punch.punchId != null) {
            Project {{ punch.projectId }} · #{{ punch.punchId }}
          } @else {
            @if (punch.projectId != null) {
              Project {{ punch.projectId }}
            } @else {
              #{{ punch.punchId }}
            }
          }
        </span>
      </div>
    }

    <!-- Category as status circle (no explicit label) -->

    @if (punch.description) {
      <div class="punch-card__row">
        <span class="punch-card__label">Description</span>
        <span class="punch-card__value">{{ punch.description }}</span>
      </div>
    }

    <!-- Status row: derived from cleared/accepted fields -->
    <div class="punch-card__row">
      <span class="punch-card__label">Status</span>
      <span class="punch-card__value">
        @if (punch.acceptedBy || punch.acceptedDate) {
          Accepted
        } @else if (punch.clearedBy || punch.clearedDate) {
          Cleared
        } @else {
          Not cleared
        }
      </span>
    </div>

    <!-- User activity / reviewer-style block: use selected-card-like layout -->
    <div class="punch-card__user-block">
      <!-- Entered by -->
      @if (punch.enteredBy || punch.enteredDate) {
        <div class="punch-card__user-card">
          <div class="punch-card__user-title">Entered</div>
          <div class="punch-card__user-selected-card">
            <div class="initial">
              {{ punch.enteredBy ? punch.enteredBy[0] || '?' : '?' }}
            </div>
            <div class="info">
              <div class="name">{{ punch.enteredBy || 'Unknown' }}</div>
              @if (punch.enteredDate) {
                <div class="meta">{{ punch.enteredDate }}</div>
              }
            </div>
          </div>
        </div>
      }

      <!-- Cleared by / Not cleared -->
      <div class="punch-card__user-card">
        <div class="punch-card__user-title">Cleared</div>
        @if (punch.clearedBy || punch.clearedDate) {
          <div class="punch-card__user-selected-card">
            <div class="initial">
              {{ punch.clearedBy ? punch.clearedBy[0] || '?' : '?' }}
            </div>
            <div class="info">
              <div class="name">{{ punch.clearedBy || 'Unknown' }}</div>
              @if (punch.clearedDate) {
                <div class="meta">{{ punch.clearedDate }}</div>
              }
            </div>
          </div>
        } @else {
          <div class="punch-card__user-selected-card punch-card__user-selected-card--empty">
            <div class="initial">!</div>
            <div class="info">
              <div class="name">Not cleared</div>
            </div>
          </div>
        }
      </div>

      <!-- Accepted by -->
      @if (punch.acceptedBy || punch.acceptedDate) {
        <div class="punch-card__user-card">
          <div class="punch-card__user-title">Accepted</div>
          <div class="punch-card__user-selected-card">
            <div class="initial">
              {{ punch.acceptedBy ? punch.acceptedBy[0] || '?' : '?' }}
            </div>
            <div class="info">
              <div class="name">{{ punch.acceptedBy || 'Unknown' }}</div>
              @if (punch.acceptedDate) {
                <div class="meta">{{ punch.acceptedDate }}</div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
